<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import AnimatedSection from "@/components/AnimatedSection.vue";

const { t } = useI18n();

const faqKeys = [
  "what_is",
  "realtime",
  "deployment_time",
  "compatibility",
  "trial",
  "data_handling",
  "support",
  "cancel",
];

const faqs = computed(() =>
  faqKeys.map((k) => ({
    question: t(`landing.faq.items.${k}.question`),
    answer: t(`landing.faq.items.${k}.answer`),
  }))
);
</script>

<template>
  <section id="faq" class="py-20 lg:py-32 bg-background">
    <div class="container mx-auto px-4 lg:px-8">
      <AnimatedSection animation="fade-up" class="text-center mb-12 lg:mb-16">
        <h2 class="text-3xl lg:text-4xl font-bold text-foreground mb-4">
          {{ t("landing.faq.title") }}
        </h2>
        <p class="text-muted-foreground text-lg max-w-2xl mx-auto">
          {{ t("landing.faq.subtitle") }}
        </p>
      </AnimatedSection>

      <AnimatedSection animation="fade-up" :delay="200" class="max-w-3xl mx-auto">
        <Accordion type="single" collapsible class="w-full">
          <AccordionItem
            v-for="(faq, index) in faqs"
            :key="index"
            :value="`item-${index}`"
            class="border-border/50"
          >
            <AccordionTrigger class="text-left text-foreground hover:text-accent hover:no-underline py-5">
              {{ faq.question }}
            </AccordionTrigger>
            <AccordionContent class="text-muted-foreground pb-5">
              {{ faq.answer }}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </AnimatedSection>
    </div>
  </section>
</template>
